var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33221 9.99952C10.3487 9.91789 15.8306 7.62237 20 3.89062C24.1694 7.62237 29.6513 9.91789 35.6678 9.99952C35.8863 11.3011 36 12.6381 36 14.0018C36 24.4515 29.3215 33.3414 20 36.6361C10.6785 33.3414 4 24.4515 4 14.0018C4 12.6381 4.11373 11.3011 4.33221 9.99952ZM27.4142 17.4159C28.1953 16.6349 28.1953 15.3685 27.4142 14.5875C26.6332 13.8064 25.3668 13.8064 24.5858 14.5875L18 21.1733L15.4142 18.5875C14.6332 17.8064 13.3668 17.8064 12.5858 18.5875C11.8047 19.3685 11.8047 20.6349 12.5858 21.4159L16.5858 25.4159C17.3668 26.197 18.6332 26.197 19.4142 25.4159L27.4142 17.4159Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shieldCheck.ae72279097906e116e4c7d4c45cc5d7f.svg";
export { ForwardRef as ReactComponent };